export default "__VITE_PUBLIC_ASSET__aacb8428__"